<template>
  <div class="i-chart-warpper">
    <div class="unconnected" v-if="!needRefresh">
      <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-alert-circle"></use>
      </svg>
      Offline
    </div>
    <img class="i-charts-alarm" slot="reference" :src="marker_alarm" v-if="onAlarm" />
    <svg class="icon" aria-hidden="true" style="font-size:128px;" :style="{fill: rateColor}">
      <use :xlink:href="rateIcon"></use>
    </svg>
    <p class="imt-2 headline">{{rate}}%</p>
  </div>
</template>

<script>
import { ERR_DATA } from './config'
export default {
  props: {
    datas: {
      type: Object,
      default: () => ({})
    },
    propName: {
      type: String,
      default: 'battery'
    },
    onAlarm: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    datas() {
      this.rate = this.datas[this.propName] == ERR_DATA ? 0 : this.datas[this.propName]
    }
  },
  data() {
    return {
      rate: this.datas[this.propName] == ERR_DATA ? 0 : this.datas[this.propName]
    }
  },
  computed: {
    needRefresh() {
      return this.datas.Status != 0
    },
    rateIcon() {
      let icon = parseInt(this.rate / 10)
      return `#icon-battery-${icon}`
    },
    rateColor() {
      let color = '#4CAF50'
      if (this.rate > 80) {
        color = '#4CAF50'
      } else if (this.rate > 50) {
        color = '#FFEB3B'
      } else if (this.rate > 10) {
        color = '#FF9800'
      } else {
        color = '#FF5722'
      }
      return color
    }
  },
  methods: {
  },
  created() {
    this.marker_alarm = require('../../../assets/icon/alarm.gif')
  }
}
</script>

<style lang="scss" scoped>
.i-chart-warpper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  .i-charts-alarm {
    position: absolute;
    top: 10px;
    left: 10px;
    width: 40px;
    height: 40px;
    z-index: 100;
  }
  .unconnected {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(96,125,139,.4);
    text-align: center;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    color: #FFF;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/charts/chart-battery.vue